import { render, staticRenderFns } from "./CreationSummary.vue?vue&type=template&id=bb10a8b0&scoped=true"
import script from "./CreationSummary.vue?vue&type=script&lang=js"
export * from "./CreationSummary.vue?vue&type=script&lang=js"
import style0 from "./CreationSummary.vue?vue&type=style&index=0&id=bb10a8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb10a8b0",
  null
  
)

export default component.exports